"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityTable = exports.EntityTableComponent = exports.EntityTableDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var use_lang_1 = require("../../hooks/use-lang");
var use_icons_1 = require("../../hooks/use-icons");
var to_array_1 = require("../../utils/to-array");
var route_1 = require("../../utils/route");
var use_entities_1 = require("../../hooks/use-entities");
var current_path_name_1 = require("../../utils/current-path-name");
var use_entity_definition_named_1 = require("../../hooks/use-entity-definition-named");
var use_modal_1 = require("../../hooks/use-modal");
var lodash_1 = require("lodash");
var theme_1 = require("@shapeable/theme");
var table_1 = require("../elements/table");
var entity_table_actions_1 = require("./entity-table-actions");
var entity_table_controls_cell_1 = require("./entity-table-controls-cell");
var client_1 = require("@apollo/client");
var router_1 = require("@reach/router");
var entity_delete_dialog_1 = require("./entity-delete-dialog");
var current_user_can_1 = require("../../utils/current-user-can");
var use_active_person_1 = require("../../hooks/use-active-person");
exports.EntityTableDefaultProps = {
  actionsWidth: 0.15,
  variant: "",
  hasDetails: false,
  isSingle: false,
  items: [],
  showControls: true
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-size: ", ";\n  "], ["\n    font-size: ", ";\n  "])), theme_1.theme.FONT_SIZE(13)),
  tablet: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: ", ";\n  "], ["\n    font-size: ", ";\n  "])), theme_1.theme.FONT_SIZE(13))
});
var TableStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (props) {
    return props._maxWidth && "\n      max-width: ".concat(props._maxWidth, ";\n    ");
  }),
  tablet: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  "], ["\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Table: (0, styled_components_1.default)(table_1.Table)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), TableStyles)
};
var EntityTableComponent = function (props) {
  var _a;
  var className = props.className,
    entityTypeName = props.entityTypeName,
    items = props.items,
    count = props.count,
    loading = props.loading,
    showControls = props.showControls,
    orderBy = props.orderBy,
    onOrderByChange = props.onOrderByChange;
  var from = (0, current_path_name_1.currentPathName)();
  var _b = __read(React.useState([]), 2),
    removedRows = _b[0],
    setRemovedRows = _b[1];
  // const [ sortDefinition, setSortDefinition ] = React.useState<OrderByDefinition>();
  var definition = (0, use_entity_definition_named_1.useEntityDefinitionNamed)(entityTypeName);
  var icons = (0, use_icons_1.useIcons)();
  var entities = (0, use_entities_1.useEntities)();
  var canRemove = !((_a = definition.table) === null || _a === void 0 ? void 0 : _a.hideRemove);
  // console.log(definition.table);
  var actionsWidth = canRemove ? props.actionsWidth : props.actionsWidth / 2;
  var user = (0, use_active_person_1.useActivePerson)();
  var data = (0, to_array_1.toArray)(props.items);
  var t = (0, use_lang_1.useLang)();
  var createTable = definition.createTable;
  var modal = (0, use_modal_1.useModal)();
  var _c = __read((0, client_1.useMutation)(definition.delete.mutation), 1),
    deleteMutation = _c[0];
  var onRowAdd = function () {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        (0, router_1.navigate)((0, route_1.route)(definition.paths.create, {
          _trailing: "from".concat(from)
        }));
        return [2 /*return*/];
      });
    });
  };
  var onRowEdit = function (entity) {
    return __awaiter(void 0, void 0, void 0, function () {
      var id;
      return __generator(this, function (_a) {
        id = entity.id;
        (0, router_1.navigate)((0, route_1.route)(definition.paths.update, {
          id: id,
          _trailing: "from".concat(from)
        }));
        return [2 /*return*/];
      });
    });
  };
  var onRowRemove = function (entity) {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        modal.show(React.createElement(entity_delete_dialog_1.EntityDeleteDialog, {
          entity: entity,
          onCancel: modal.hide,
          onComplete: function () {
            setRemovedRows(__spreadArray(__spreadArray([], __read(removedRows), false), [entity.id], false));
            modal.hide();
          },
          mutation: deleteMutation
        }));
        return [2 /*return*/];
      });
    });
  };
  // Map entity data array to cells using configuration, and add actions cell
  var columns = createTable ? (0, lodash_1.filter)(createTable({
    icons: icons,
    definition: definition,
    entities: entities,
    t: t,
    hasDetails: props.hasDetails
  })) : [];
  var controlsAreVisible = showControls && ((0, current_user_can_1.personCanUpdate)(user, definition.scopeSlug) || (0, current_user_can_1.personCanDelete)(user, definition.scopeSlug));
  var tableData = (0, lodash_1.mapValues)((0, lodash_1.keyBy)((0, lodash_1.filter)(data, function (entity) {
    return !(0, lodash_1.includes)(removedRows, entity.id);
  }), function (entity) {
    return entity.id;
  }), function (entity) {
    return {
      id: entity.id,
      cells: (0, lodash_1.filter)(__spreadArray(__spreadArray([], __read((0, lodash_1.map)(columns, function (_a) {
        var name = _a.name,
          renderValue = _a.renderValue;
        return {
          name: name,
          isSortable: true,
          value: renderValue && renderValue({
            entity: entity
          }) || entity
        };
      })), false), [controlsAreVisible && {
        name: "actions",
        value: React.createElement(entity_table_actions_1.EntityTableActions, {
          entityTypeName: entityTypeName,
          onEdit: function () {
            return onRowEdit(entity);
          },
          onRemove: canRemove ? function () {
            return onRowRemove(entity);
          } : null
        })
      }], false))
    };
  });
  var rows = (0, lodash_1.map)(items, "id");
  var controls = controlsAreVisible && React.createElement(entity_table_controls_cell_1.EntityTableControlsCell, {
    loading: loading,
    entityTypeName: entityTypeName,
    onAdd: onRowAdd,
    count: count || items && items.length
  });
  var availableWidth = controlsAreVisible ? 1 - actionsWidth : 1;
  var totalWeight = (0, lodash_1.sumBy)(columns, function (column) {
    return column.weight || 2;
  });
  var tableColumns = (0, lodash_1.mapValues)((0, lodash_1.keyBy)(columns, 'name'), function (column) {
    return __assign(__assign({}, column), {
      hasDetails: props.hasDetails,
      isSortable: definition.orderBySchemaFields.includes(column.name),
      orderByDirection: (orderBy === null || orderBy === void 0 ? void 0 : orderBy.fieldName) === definition.orderBySchemaFieldsByColumnName[column.name] ? orderBy.direction : undefined,
      width: "".concat(availableWidth * 100 * ((column.weight || 2) / totalWeight), "%")
    });
  });
  if (controlsAreVisible) {
    tableColumns.actions = {
      // name: 'actions',
      renderValue: null,
      width: canRemove ? "160px" : "80px",
      align: "center",
      title: t("Actions"),
      icon: icons.GearsCircle
    };
  }
  var onTableHeadCellClick = function (name) {
    if (onOrderByChange) {
      var _a = orderBy || {},
        columnName = _a.fieldName,
        direction = _a.direction;
      var fieldName = definition.orderBySchemaFieldsByColumnName[name] || name;
      var currentColumnName = definition.orderByColumnNamesBySchemaField[columnName] || columnName;
      if (currentColumnName === name) {
        var newDirection = direction === "asc" ? "desc" : "asc";
        // console.log(`${newDirection} ON`, name);
        onOrderByChange({
          fieldName: fieldName,
          direction: newDirection
        });
      } else {
        // console.log("SORT ON", name);
        onOrderByChange({
          fieldName: fieldName,
          direction: "asc"
        });
      }
    }
  };
  return React.createElement(My.Container, {
    className: className
  }, React.createElement(My.Table, {
    onTableHeadCellClick: onTableHeadCellClick,
    variant: "list",
    header: items.length > 10 && controls,
    footer: controls,
    rows: rows,
    columns: tableColumns,
    data: tableData
  }));
};
exports.EntityTableComponent = EntityTableComponent;
exports.EntityTableComponent.defaultProps = exports.EntityTableDefaultProps;
exports.EntityTable = exports.EntityTableComponent;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;